import { useContext } from "react";

import { useTranslation } from "react-i18next";
import { Step } from "react-joyride";

import TutorialContext from "context/tutorial/tutorialContext";
import { useMediaQueries } from "shared/hooks/useMediaQueries";

import {
    BODY,
    BURGER_BUTTON,
    COMPANY_SELECTOR_BUTTON,
    COMPANY_SELECTOR_BUTTON_MOBILE,
    COMPANY_SELECTOR_MENU,
    DESKTOP_DRAWER,
    TASKS_LIST_CHOICE
} from "./constants";

const useTutorialStepGroups = () => {
    const { isInitialRender } = useContext(TutorialContext);

    const { t } = useTranslation();
    const { toSm, fromMd } = useMediaQueries();

    const firstTimeUserSteps: Step[] = [
        {
            target: BODY,
            title: t("Tutorial##titles##first time user"),
            content: t("Tutorial##content##first time user"),
            placement: "center"
        }
    ];

    const companySelectorSteps: Step[] = [
        {
            target: toSm
                ? `#${COMPANY_SELECTOR_BUTTON_MOBILE}`
                : `#${COMPANY_SELECTOR_BUTTON}`,
            title: t("Filter##company selector"),
            content: t("Tutorial##content##company selector##0"),
            placement: "bottom"
        },
        {
            target: fromMd ? `#${COMPANY_SELECTOR_MENU}` : BODY,
            title: t("Filter##company selector"),
            content: `${t("Tutorial##content##company selector##1")} ${isInitialRender ? t("Tutorial##content##company selector##1-info") : ""}`,
            placement: fromMd ? "left-start" : "center"
        }
    ];

    const taskGroupsSteps: Step[] = [
        {
            target: fromMd ? `#${DESKTOP_DRAWER}` : `#${BURGER_BUTTON}`,
            title: t("General##task groups"),
            content: t("Tutorial##content##task groups##desktop##0"),
            placement: "right-start"
        },
        {
            target: BODY,
            title: t("General##task groups"),
            content: t("Tutorial##content##task groups##desktop##1"),
            placement: "center"
        }
    ];

    const taskGroupsStepsMobile: Step[] = [
        {
            target: `#${BURGER_BUTTON}`,
            title: t("General##task groups"),
            content: t("Tutorial##content##task groups##mobile##0"),
            placement: "right-start"
        },
        {
            target: `#${TASKS_LIST_CHOICE}`,
            title: t("General##task groups"),
            content: t("Tutorial##content##task groups##mobile##1"),
            placement: "bottom"
        },
        {
            target: BODY,
            title: t("General##task groups"),
            content: t("Tutorial##content##task groups##desktop##1"),
            placement: "center"
        }
    ];

    const finishTutorialSteps: Step[] = [
        {
            target: BODY,
            title: t("Tutorial##titles##finish tutorial"),
            content: t("Tutorial##content##finish tutorial"),
            placement: "center"
        }
    ];

    return {
        companySelectorSteps,
        firstTimeUserSteps,
        finishTutorialSteps,
        taskGroupsSteps,
        taskGroupsStepsMobile
    };
};

export default useTutorialStepGroups;
